'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'Australian Capital Territory': 'act',
  'New South Wales': 'nsw',
  'Northern Territories': 'nt',
  Queensland: 'qld',
  'South Australia': 'sa',
  Tasmania: 'tas',
  Victoria: 'vic',
  'Western Australia': 'wa',
  'New Zealand': 'nz',
  'UK & Ireland': 'uk',
  Overseas: 'overseas'
};